export const environment = {
  production: false,
  local: false,
  apiUrl: 'https://api-qat.service.ford.com/saapi/parts-logistics/claims',
};
